export const handleGetFileExtension = function (filePath: string) {
  let result = filePath?.split(".");
  let extension = result.length > 0 ? result[result.length - 1] : "";
  return extension;
};
